import { resolveSafeRedirect } from '@/utilities/safeRedirect'

export const SIGN_UP_PATH = '/sign-up'
export const SIGN_IN_PATH = '/sign-in'
export const JOIN_PATH = '/join'
export const DASHBOARD_PATH = '/dashboard'

type SignUpLandingArgs = {
  redirectTo?: string | null
}

/**
 * True when the path is the memberships page, including query or hash.
 */
export function isJoinPath(path: string): boolean {
  return path === JOIN_PATH || path.startsWith(`${JOIN_PATH}?`) || path.startsWith(`${JOIN_PATH}#`)
}

/**
 * Returns a safe post-auth path, or null when the input is empty or points at /join.
 */
export function sanitizeAuthRedirect(redirectTo?: string | null): string | null {
  const safe = resolveSafeRedirect(redirectTo)
  if (!safe || isJoinPath(safe)) return null
  return safe
}

/**
 * Post-auth destination for sign-in and sign-up.
 * Never returns /join; defaults to /dashboard.
 */
export function resolveAuthLanding(redirectTo?: string | null): string {
  return sanitizeAuthRedirect(redirectTo) ?? DASHBOARD_PATH
}

/**
 * Builds the account sign-up URL, optionally carrying a post-auth redirect.
 * /join and /dashboard are omitted from the query; dashboard is already the default.
 */
export function signUpHref(redirectTo?: string | null): string {
  const safe = sanitizeAuthRedirect(redirectTo)
  if (!safe || safe === DASHBOARD_PATH) return SIGN_UP_PATH
  return `${SIGN_UP_PATH}?redirectTo=${encodeURIComponent(safe)}`
}

/**
 * Where a new account should land after sign-up.
 * Honors a safe non-join redirectTo; otherwise /dashboard.
 */
export function resolveSignUpLanding({ redirectTo }: SignUpLandingArgs): string {
  return resolveAuthLanding(redirectTo)
}
